<div class="container-fluid">
  <div class="row" style="background-color: white; display: flex;">
    <div class="row">
      <div class="col-lg-4 padding-box">
        <app-company-dropdown (companySelection)="comapnySelectionChange($event)"></app-company-dropdown>
      </div>
      <div class="search-group col-lg-6">

      </div>
      <div class="col-lg-2">

      </div>
    </div>
    <div class="search-group content col d-flex justify-content-between"
      style="margin-right: -80px; background-color: white;">
      <app-search-bar style="margin-right: -80px;" (search)="onSearch($event)" [searchText]="dataSearch" selected="1" />
      <!-- <section class="searchBarContainer search-group d-flex">
        <input type="text" class="form-control text-search " [(ngModel)]="dataSearch" style="height: 35px;">
        <button class="btn btn-primary btn-search btn-sm d-flex align-items-center" (click)="onSearch($event)">
          <i class="material-icons-outlined" style="display: inline-block">search</i>&nbsp;
          <span class="btn-text">
            Search
          </span>

        </button>
      </section> -->

      <!-- @if(orderheaderPagination){ -->
      <app-pagination-bar style="float: right;" [firstPage]="orderheaderPagination?orderheaderPagination.first:''" (changePageNumber)="checkForPAgeNUmberChange($event)"
      [odin]="true"
        [lastPage]="orderheaderPagination?orderheaderPagination.last:''"
        [totalElement]="orderheaderPagination?orderheaderPagination.numberOfElements:''"
        [pageSize]="orderheaderPagination?orderheaderPagination.size:''"
        [totalPages]="orderheaderPagination?orderheaderPagination.totalPages:''"
        [totalElements]="orderheaderPagination?orderheaderPagination.totalElements:''"
        [currentPage]="orderheaderPagination?orderheaderPagination.number:''"
        [from]="orderheaderPagination?((orderheaderPagination.number*orderheaderPagination.size) + 1):0"
        [to]="orderheaderPagination?((orderheaderPagination.number*orderheaderPagination.size) + orderheaderPagination.numberOfElements):0"
        (startPage)="doOrderHeaderPageSearch(0)"
        (finalPage)="doOrderHeaderPageSearch(orderheaderPagination.totalPages - 1)"
        (previousPage)="doOrderHeaderPageSearch(orderheaderPagination.number-1)"
        (nextPage)="doOrderHeaderPageSearch(orderheaderPagination.number+1)">
      </app-pagination-bar>
      <!-- } -->

    </div>

    <div class="row" style="height: 400px; overflow: auto; padding: 0px; margin: 0px;">
      <!-- @if(dataSourceOrderHeader?.length==0){
  
        } @else { -->


      @if(selectedDropdwnData=='2'){
      <ag-grid-angular #agGrid4 class="flex-grow-1 ag-theme-quartz" [rowData]="dataSourceOrderHeader"
        [columnDefs]="colDefsOrder" [rowSelection]="rowSelection" [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)" [initialState]="gridOptions.initialState"
        (sortChanged)="onSortChanged($event)"  (modelUpdated)="onModelUpdated($event)"  (selectionChanged)="onOrderSelectionChanged()">
      </ag-grid-angular>
      } @else{
      <ag-grid-angular #agGrid2 class="flex-grow-1 ag-theme-quartz" [rowData]="dataSourceCoilHeader"
        [columnDefs]="colDefsCoil" [rowSelection]="rowSelection" [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)" [initialState]="gridOptions.initialState"
        (sortChanged)="onSortChanged($event)"  (modelUpdated)="onModelUpdated($event)"  (selectionChanged)="onOrderSelectionChanged()">
      </ag-grid-angular>
      }


      <!-- } -->
    </div>
  </div>

  <!-- Two Columns in a Row -->
  <div class="row">
    <div class="col-md-6">
      <header class="  text-center py-3">
        <!-- <h6>Material Status Data</h6> -->
      </header>
      <div class="p-3 pt-0 border bg-light">
        <br>
        <h6>Material Status Data</h6>
        <br>
        @if (showordermaterialdatatable){
        <app-material-data [orderPost]="materialOrderPost"></app-material-data>
        } @else {
        <!-- <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
          <p style="font-size: 20px; color: white">Loading...</p>
        </ngx-spinner> -->
        }
      </div>
    </div>
    <div class="col-md-6">
      <header class="  text-center py-3">
      </header>

      <div class="p-3  pt-0 border bg-light">
        <br>
        @if(materialOrderPost && !MTOFlag ){
        <button class="btn btn-primary btn-search btn-sm d-flex align-items-center" style="float: inline-end;"
          (click)="changeViewForMTA()">
          <!-- <i class="material-icons-outlined" style="display: inline-block">search</i>&nbsp; -->
          <i class="material-icons">list</i>&nbsp;
          @if(!mtaFlag){
          <span class="btn-text">
            MTF-MTA View
          </span>
          }@else{

          <span class="btn-text">
            Quantity View
          </span>


          }


        </button>
        }


        @if(mtaFlag){
        <h6>MTA-MTF Data Flow</h6>
        }@else{
        <h6>Quantity Status Data</h6>
        }

        <br>
        @if (showordermaterialdatatable){
        @if(!mtaFlag){
        <app-quantity-data [orderPost]="materialOrderPost" (stockProjValue)="getProjection($event)"></app-quantity-data>
        }@else{
        <app-mta-mtf [orderPost]="materialOrderPost"></app-mta-mtf>
        }



        } @else {
        <!-- <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
          <p style="font-size: 20px; color: white">Loading...</p>
        </ngx-spinner> -->
        }
      </div>

    </div>
  </div>

 <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
  </ngx-spinner>
  <!-- </div> -->
</div>